import { CONFIG_DEFAULT } from "./defaults";
import { BodyMutationObserver } from "./body-mutation-observer";

export default async (): Promise<void> => {
    if (typeof window === "undefined") {
        return;
    }
    if (window.trumpf) {
        // Check if Trumpf namespaces present
        if (window.trumpf.ux) {
            // patch default values to config default
            window.trumpf.ux = { ...CONFIG_DEFAULT, ...window.trumpf.ux };
        } else {
            window.trumpf.ux = { ...CONFIG_DEFAULT };
        }
    } else {
        // Create Trumpf namespace
        window.trumpf = {
            ux: { ...CONFIG_DEFAULT }
        };
    }
    new BodyMutationObserver();
};
